import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5e53c228"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel } from '@vueuse/core';
import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { savePayment } from '@/api/payment.js';
export default {
  __name: 'addPayTenantDialog',
  props: {
    // 是否回显数据
    model: {
      type: Object,
      default: null
    },
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue', 'refreshData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    // 表单数据
    const formData = ref({
      name: '',
      // 应用名称
      platform: 'p1',
      // 应用所属平台，1：华夏银行，2：兴业银行
      keyId: '',
      // 服务商编号 机构号(兴业银行)
      privateKey: '',
      // 商户私钥  签名私钥(兴业银行)
      publicKey: '',
      // 服务公钥  响应报文验签公钥(兴业银行)
      mchId: '',
      // 商户id(由平台分配) 商户号(兴业银行)
      appId: '',
      // 应用ID(兴业银行)
      encryptKey: '',
      // 字段加密密钥(兴业银行)
      terminalId: '' // 终端编号(兴业银行)
    });
    const resetForm = () => {
      formData.value = {
        name: '',
        // 应用名称
        platform: 'p1',
        // 应用所属平台，1：华夏银行，2：兴业银行
        keyId: '',
        // 服务商编号 机构号(兴业银行)
        privateKey: '',
        // 商户私钥  签名私钥(兴业银行)
        publicKey: '',
        // 服务公钥  响应报文验签公钥(兴业银行)
        mchId: '',
        // 商户id(由平台分配) 商户号(兴业银行)
        appId: '',
        // 应用ID(兴业银行)
        encryptKey: '',
        // 字段加密密钥(兴业银行)
        terminalId: '' // 终端编号(兴业银行)
      };
    };
    watch(() => props.model, val => {
      if (val) {
        formData.value = {
          id: val.id,
          ...JSON.parse(JSON.stringify(val))
        };
      } else {
        console.log('noModel:');
        resetForm();
      }
    }, {
      deep: true,
      immediate: true
    });
    const emits = __emit;
    const isVisible = useVModel(props);
    const rules = ref({
      name: [{
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }],
      encryptKey: [{
        max: 100,
        message: '字段加密密钥长度不能超过100'
      }]
    });

    // 表单元素
    const formEl = ref(null);
    /**
     * 新增事件
     */
    const addNewsTenantHandler = async () => {
      if (!formEl.value) return;
      await formEl.value.validate(async (valid, fields) => {
        if (valid) {
          try {
            await savePayment(formData.value);
            emits('refreshData');
            ElMessage({
              type: 'success',
              message: props.model ? '修改成功' : '添加成功'
            });
          } catch (error) {
            console.log(error, 'error');
          } finally {
            isVisible.value = false;
          }
        } else {
          ElMessage({
            type: 'error',
            message: '验证失败'
          });
        }
      });
    };
    const closed = () => {
      formEl.value.resetFields();
      resetForm();
      if (props.model) {
        emits('clearModel');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        title: __props.model ? '修改应用' : '新增应用',
        width: "50%",
        onClosed: closed,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: addNewsTenantHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          model: formData.value,
          rules: rules.value,
          style: {
            "max-width": "90%"
          },
          ref_key: "formEl",
          ref: formEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "企业名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.name = $event),
              placeholder: "请输入企业名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "应用所属平台"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: formData.value.platform,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.platform = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                border: "",
                label: "p1"
              }, {
                default: _withCtx(() => [_createTextVNode("华夏银行")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                border: "",
                label: "p2"
              }, {
                default: _withCtx(() => [_createTextVNode("兴业银行")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: formData.value.platform === 'p1' ? '服务商编号' : '机构号'
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.keyId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.keyId = $event),
              placeholder: `请输入${formData.value.platform === 'p1' ? '服务商编号' : '机构号'}`
            }, null, 8, ["modelValue", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: formData.value.platform === 'p1' ? '商户id' : '商户号'
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.mchId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.mchId = $event),
              placeholder: `请输入${formData.value.platform === 'p1' ? '商户id' : '商户号'}`
            }, null, 8, ["modelValue", "placeholder"])]),
            _: 1
          }, 8, ["label"]), formData.value.platform === 'p2' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "应用id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.appId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.appId = $event),
              placeholder: "请输入应用id"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), formData.value.platform === 'p2' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "终端编号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.terminalId,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.value.terminalId = $event),
              placeholder: "请输入终端编号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), formData.value.platform === 'p2' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "字段加密密钥",
            prop: "encryptKey"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              autosize: {
                minRows: 5
              },
              modelValue: formData.value.encryptKey,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.value.encryptKey = $event),
              placeholder: "请输入字段加密密钥",
              "show-word-limit": "",
              maxlength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: formData.value.platform === 'p1' ? '商户私钥' : '签名私钥'
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              autosize: {
                minRows: 5
              },
              modelValue: formData.value.privateKey,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.value.privateKey = $event),
              placeholder: `请输入${formData.value.platform === 'p1' ? '商户私钥' : '签名私钥'}`
            }, null, 8, ["modelValue", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: formData.value.platform === 'p1' ? '服务公钥' : '响应报文验签公钥'
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              autosize: {
                minRows: 5
              },
              modelValue: formData.value.publicKey,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.value.publicKey = $event),
              placeholder: `请输入${formData.value.platform === 'p1' ? '服务公钥' : '响应报文验签公钥'}`
            }, null, 8, ["modelValue", "placeholder"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};